<template>
  <Modal :title="title">
    <StreamsUsersTable :streams-users="activeStreamsUsers" />
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";
import { Stream } from "shared/resources";

import StreamsUsersTable from "src/components/streams/StreamsUsersTable.vue";

export default {
  name: "StreamsUsersModal",
  components: {
    Modal,
    StreamsUsersTable,
  },
  props: {
    stream: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeStreamsUsers: [],
    };
  },
  computed: {
    title() {
      return `Users with access to Stream: ${this.stream.id}`;
    },
  },
  mounted() {
    this.loadStream();
  },
  methods: {
    async loadStream() {
      try {
        const response = await Stream.includes([
          "user",
          { streamsUsers: ["user"] },
        ])
          .where({
            streamsUsers: { archived: false },
          })
          .find(this.stream.id);

        this.activeStreamsUsers = response.data.streamsUsers.filter(
          ({ user }) => user.active
        );
      } catch (error) {
        this.$error(
          `Unable to load mention stream id ${this.stream.id}`,
          error
        );
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.streem-dialog {
  background-color: rgb(255 255 255);
}
</style>
